module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "id": "top-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', [_vm._v("Want some Appetizing Food?")]), _vm._v(" "), _c('h2', [_vm._v("Grab yours now!")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger btn-fill",
    attrs: {
      "to": "/menu",
      "tag": "button"
    }
  }, [_vm._v("\n              Browse the Menu\n            ")]), _vm._v(" "), _vm._m(0)], 1)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "featured-menu"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-items"
  }, [(_vm.products) ? _c('div', {
    staticClass: "row row-eq-height"
  }, [_vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "animated zoomIn col-md-3 product-item"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "image"
    }, [(product.gallery.length) ? _c('img', {
      attrs: {
        "src": _vm.base_url + '/' + product.gallery[0].image_path,
        "alt": product.title
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/img/food.png"),
        "alt": product.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('p', {
      staticClass: "item-category"
    }, [_c('small', [_vm._v(_vm._s(product.category.title))])]), _vm._v(" "), _c('p', {
      staticClass: "item-description"
    }, [_vm._v("\n                    " + _vm._s(product.description) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('span', {
      staticClass: "q-add",
      on: {
        "click": function($event) {
          product.quantity++
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "q-total"
    }, [_vm._v(_vm._s(product.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "q-sub",
      on: {
        "click": function($event) {
          product.quantity > 1 ? product.quantity-- : product.quantity
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-md-6 text-left"
    }, [_c('b-button', {
      staticClass: "btn-danger btn-sm",
      attrs: {
        "disabled": !product.availability
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product.title, product.code, product.gallery.length ? _vm.base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)
        }
      }
    }, [_vm._v(_vm._s(product.availability ? 'Add to cart' : 'Out of stock') + "\n                      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 text-right"
    }, [(product.discount > 0) ? _c('span', {
      staticClass: "total-price has-discount"
    }, [_c('span', {
      staticClass: "old-price"
    }, [_vm._v("£" + _vm._s(product.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£" + _vm._s(product.discount.toFixed(2)))])]) : _c('span', {
      staticClass: "total-price"
    }, [_vm._v("\n                        £ " + _vm._s(product.price.toFixed(2)) + "\n                      ")])])])])])])
  }), _vm._v(" "), (_vm.products.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n              There are no featured products to display. Check Menu page.\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(3)]) : _vm._e()]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "mid-bg-separator text-center"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('router-view', {
    on: {
      "getFeaturedProducts": _vm.getFeaturedProducts
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "discount-text-header"
  }, [_vm._v("Get a 10% discount using the code "), _c('strong', [_vm._v("V21CU23")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bg"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/top-bg.jpg"),
      "alt": "Kungfood background"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-bg-separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Featured Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "loader-1"
  }, [_c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepageDiscount"
    }
  }, [_c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "ticket-content"
  }, [_c('h1', [_vm._v("10% OFF")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "margin": "5px 0 15px"
    }
  }, [_vm._v("For orders above 10£")]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Voucher code")]), _c('br'), _vm._v("\n                V21CU23\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "process-overview"
    }
  }, [_c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "plater",
    attrs: {
      "src": require("../../assets/img/plate-delimiter.png"),
      "alt": "Chopstix plate"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-left",
    attrs: {
      "src": require("../../assets/img/lamps-left.png"),
      "align": "Lamps ornaments"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": require("../../assets/img/lamps-right.png"),
      "align": "Lamps ornaments"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("\n            How it works?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/location-icon.png"),
      "alt": "Select a Restaurant"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Select a restaurant")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/food-icon.png"),
      "alt": "Pick a tasty dish"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Pick a tasty dish")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/delivery-icon.png"),
      "alt": "Get your delivery"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Collect or deliver to your door")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("3")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "buildings-separator"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01723053!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/homepage.vue
// module id = 541
// module chunks = 1